// SignalR Protocol Message Types
// Based on SignalR Hub Protocol specification
export enum SignalRMessageType {
  Invocation = 1, // type: 1 - Server invoking a hub method on the client
  StreamItem = 2, // type: 2 - Server sending a stream item
  Completion = 3, // type: 3 - Server completing a hub method invocation
  StreamInvocation = 4, // type: 4 - Client invoking a streaming hub method
  CancelInvocation = 5, // type: 5 - Client canceling a streaming invocation
  Ping = 6, // type: 6 - Keep-alive ping
  Close = 7, // type: 7 - Close message
}

export enum SignalRConnection {
  JOIN_GROUP = 'JoinGroup',
  LEAVE_GROUP = 'LeaveGroup',
}
export enum ActionSignalR {
  STATION_UPDATE = 'StationUpdate',
  WeatherLinkUpdate = 'WeatherLinkUpdate',
  ProgramStatusUpdate = 'ProgramStatusUpdate',
  DiagnosticUpdate = 'DiagnosticUpdate',
  WaterTankUpdate = 'WaterTankUpdate',
  CisgenicTaskUpdate = 'CisgenicTaskUpdate',
  InterfaceBackupUpdate = 'InterfaceBackupUpdate',
}

// SignalR Station Update event structure
export interface StationUpdateEventData {
  controllerValue: number
  id: number
  name: string
  imageUrl: string
  s3Url: string
}

// Controller value constants for station status
export enum ControllerValue {
  ERROR = -1,
  OFF = 0,
  ON = 1,
  WAITING = 2,
}

export const getGroupName = (interfaceId: number) => `interface:${interfaceId}`
export const getUserName = (userId: number) => `user:${userId}`
